/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

import React from 'react'
import { LanguageProvider } from './src/contexts/LanguageContext'
import './src/styles/global.css'

// Wrap the root element with LanguageProvider
export const wrapRootElement = ({ element }) => (
  <LanguageProvider>
    {element}
  </LanguageProvider>
)

// 每次路由变化时发送百度统计PV
export const onRouteUpdate = ({ location }) => {
  if (window._hmt) {
    window._hmt.push(['_trackPageview', location.pathname])
  }
}
